import { render, staticRenderFns } from "./versionTable.vue?vue&type=template&id=60e59b9e&scoped=true&lang=pug"
import script from "./versionTable.vue?vue&type=script&lang=js"
export * from "./versionTable.vue?vue&type=script&lang=js"
import style0 from "./versionTable.vue?vue&type=style&index=0&id=60e59b9e&prod&lang=scss&scoped=true"
import style1 from "./versionTable.vue?vue&type=style&index=1&id=60e59b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e59b9e",
  null
  
)

export default component.exports